export const USER_LOGOUT = 'root/USER_LOGOUT';
